/* AniMALL CRO 2026-10-05 · fechas estimadas de entrega y "Completa tu pedido". Sin dependencias. */
(function () {
  // Días festivos oficiales (LFT art. 74) que no cuentan como hábiles.
  var FESTIVOS = ['2026-11-16', '2026-12-25', '2027-01-01', '2027-02-01', '2027-03-15', '2027-05-01', '2027-09-16', '2027-11-15', '2027-12-25'];
  var DIAS = ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'];
  var MESES = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'];

  function hoyCDMX() {
    try {
      var p = new Intl.DateTimeFormat('en-CA', { timeZone: 'America/Mexico_City', year: 'numeric', month: '2-digit', day: '2-digit' }).format(new Date()).split('-');
      return new Date(Date.UTC(+p[0], +p[1] - 1, +p[2]));
    } catch (e) {
      var d = new Date();
      return new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
    }
  }
  function sumarHabiles(base, n) {
    var d = new Date(base.getTime()), c = 0;
    while (c < n) {
      d.setUTCDate(d.getUTCDate() + 1);
      var w = d.getUTCDay();
      if (w !== 0 && w !== 6 && FESTIVOS.indexOf(d.toISOString().slice(0, 10)) === -1) c++;
    }
    return d;
  }
  function rango(a, b) {
    var ia = DIAS[a.getUTCDay()] + ' ' + a.getUTCDate();
    var ib = DIAS[b.getUTCDay()] + ' ' + b.getUTCDate() + ' de ' + MESES[b.getUTCMonth()];
    if (a.getUTCMonth() !== b.getUTCMonth()) ia += ' de ' + MESES[a.getUTCMonth()];
    return 'entre el <strong>' + ia + '</strong> y el <strong>' + ib + '</strong>';
  }

  if (!customElements.get('animall-eta')) {
    customElements.define('animall-eta', class extends HTMLElement {
      connectedCallback() {
        var hoy = hoyCDMX();
        var est = rango(sumarHabiles(hoy, +(this.dataset.min || 2)), sumarHabiles(hoy, +(this.dataset.max || 7)));
        var exp = rango(sumarHabiles(hoy, +(this.dataset.expressMin || 2)), sumarHabiles(hoy, +(this.dataset.expressMax || 3)));
        this.innerHTML = 'Llega ' + est + ' con envío estándar, o ' + exp + ' con Express (fechas estimadas).';
      }
    });
  }

  if (!customElements.get('animall-completa-pedido')) {
    customElements.define('animall-completa-pedido', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.cargado || !this.dataset.productId || !this.dataset.url) return;
        this.dataset.cargado = '1';
        var self = this;
        this.cargar('complementary').then(function (ok) { return ok || self.cargar('related'); });
      }
      cargar(intent) {
        var self = this;
        var url = this.dataset.url + '?section_id=animall-completa-pedido&limit=10&intent=' + intent + '&product_id=' + encodeURIComponent(this.dataset.productId);
        return fetch(url).then(function (r) { return r.ok ? r.text() : ''; }).then(function (html) {
          if (!html) return false;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var bloque = doc.querySelector('.animall-cp');
          if (!bloque || !bloque.querySelector('.animall-cp__item')) return false;
          self.innerHTML = bloque.outerHTML;
          self.hidden = false;
          return true;
        }).catch(function () { return false; });
      }
    });
  }
  // v2 · Altura real del sticky "Agregar al carrito" para subir Smile/Kommo justo encima (ver animall-cro.css).
  var sticky = document.querySelector('sticky-cart-modal');
  if (sticky) {
    var fijarAltura = function () {
      var h = sticky.offsetHeight;
      if (h) document.documentElement.style.setProperty('--animall-sticky-h', h + 'px');
    };
    fijarAltura();
    if (window.ResizeObserver) new ResizeObserver(fijarAltura).observe(sticky);
  }
})();
